import script from "./CustomResourceApplyBMX.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyBMX.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyBMX.vue?vue&type=style&index=0&id=386430e0&lang=less&scope=true"

const __exports__ = script;

export default __exports__